module.exports = __webpack_public_path__ + "img/skill.0877728f.jpg";